'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getCellValue, isSameIgnoreCase } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { verifyext, verifycsvdata } from "../common/verifyext";
import { Edit, Trash } from 'lucide-react';
import AddEditController from './addEditController.js';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmVehicleCapacity extends Component {
    static contextType = LoadingPortContext;

    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                // editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                actionRenderer: this.ActionRenderer
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-n",
            loadshow: "show-n",
            holidayEvents: [],
            maxNodes: [],
            telRoutes: [],
            deviation: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            // Warehouse-level Courier Hold CMT limit (lmwarehouseconfig) — tab-agnostic, one value
            // per warehouse. Consignees whose courier load exceeds this CMT are held (Courier HOLD).
            courierHoldCmtLimit: "",
            savingWhConfig: false,
            zones: [],
            selectedZone: null,
            showGridData: "show-m",
            vehicleTypes: [],
            data_type: 1,
            regularActive: "activet",
            truckActive: "",
            courierActive: "", airCourierActive: "",
            controller: {
                open: false
            },
            hubVehicleTypes: [], hub_vehicle: 0, air_courier_vehicle: 0,
            rowIds: [], selectedRows: [], errors: [], validData: []
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        // this.onCellClicked = this.onCellClicked.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
        this.gridRef = React.createRef();
        this.fileInputRef = React.createRef();
    }


    componentDidMount() {
        loadDateTimeScript();
        this.pageAccess();
        var maxNodes = [];
        for (let i = 1; i <= 100; i++) {
            maxNodes.push(i);
            this.setState({ maxNodes });
        }
        var telRoutes = [];
        telRoutes.push("Disable");
        telRoutes.push("Enable");
        this.setState({ telRoutes });
        var deviation = ["Disable", 5, 10, 15, 20, 25, 30];
        this.setState({ deviation });
        // Non-hub vehicle types offered on the Regular / Dedicated / Surface Courier tabs.
        // ⚠ This is the ONE list that gates a new vehicle type end to end: every other master
        // (Freights, Consignee "Restricted Vehicles") builds its dropdown from the vehicle_cap
        // values already saved here, so a type must exist in this list before it can be
        // configured anywhere else. Keep in sync with the engine's defines.VEHICLE_ORDER_LIST.
        var vehicleTypes = ["32 FT Vehicle", "20 FT Vehicle", "20 FT Small", "14 FT Vehicle", "7 FT Vehicle"]
        this.setState({ vehicleTypes, hubVehicleTypes: ["32 FT HUB Vehicle", "20 FT HUB Vehicle"] });
    }

    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.loadZoneOptions(resolved.loading_port_code);
        this.loadWarehouseConfig(resolved.loading_port_code);
        await this.onloadPageData();
    }

    onloadPageData() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type,
            hub_vehicle: this.state.hub_vehicle,
            air_courier_vehicle: this.state.air_courier_vehicle,
            zone: this.isZoneTab() ? (this.state.selectedZone || "") : ""
        }
        console.log(params, "params")
        redirectURL.post("/lmconsignees/getLmVehicleCapacity", params).then((response) => {
            console.log(response.data);
            var rowData = response.data;
            // rowData.map(function (e) {
            //     if (e.telescopic_route == 1) {
            //         e['telescopic_route'] = "Enable";
            //     }
            //     else {
            //         e['telescopic_route'] = "Disable";
            //     }
            // });
            this.setState({
                rowData: rowData,
                loadshow: 'show-n',
                overly: 'show-n',
            })
        }).catch((e) => {
            console.log(e);
        })
    }

    // Load the warehouse-level Courier Hold CMT limit for the current port (tab-agnostic).
    loadWarehouseConfig(loading_port_code) {
        if (!loading_port_code) return;
        redirectURL.post("/lmconsignees/getWarehouseConfig", { loading_port_code: loading_port_code, status: 1 }).then((response) => {
            if (response.data && response.data.status == "success" && response.data.data && response.data.data.length > 0) {
                var cfg = response.data.data[0];
                this.setState({
                    courierHoldCmtLimit: (cfg.courier_hold_cmt_limit != undefined && cfg.courier_hold_cmt_limit != null)
                        ? String(cfg.courier_hold_cmt_limit) : ""
                });
            } else {
                this.setState({ courierHoldCmtLimit: "" });
            }
        }).catch((e) => {
            console.log(e);
            this.setState({ courierHoldCmtLimit: "" });
        });
    }

    // Save the warehouse-level Courier Hold CMT limit for the current port.
    saveWarehouseConfig = async () => {
        var loading_port_code = this.state.loading_port_code;
        if (!loading_port_code) return;
        var raw = this.state.courierHoldCmtLimit;
        var val = (raw === "" || raw === null || raw === undefined) ? 0 : Number(raw);
        if (isNaN(val) || val < 0) {
            this.setState({ show: true, basicType: "error", basicTitle: "Enter a valid non-negative CMT value." });
            return;
        }
        try {
            this.setState({ savingWhConfig: true });
            const response = await redirectURL.post("/lmconsignees/saveWarehouseConfig", {
                loading_port_code: loading_port_code,
                courier_hold_cmt_limit: val
            });
            if (response.data && response.data.status == "success") {
                this.setState({ show: true, basicType: "success", basicTitle: "Courier Hold CMT Limit saved." });
            } else {
                this.setState({ show: true, basicType: "error", basicTitle: (response.data && response.data.message) || "Save failed. Please try again." });
            }
        } catch (e) {
            console.log(e);
            this.setState({ show: true, basicType: "error", basicTitle: "Save failed. Please try again." });
        } finally {
            this.setState({ savingWhConfig: false });
        }
    }

    fetchZones(loading_port_code, requestId) {
        return redirectURL.post("/lmconsignees/getLmSobUniqueZones", { loading_port_code }).then((response) => {
            // A newer loadZoneOptions call (e.g. the user switched tabs again
            // before this request landed) has already superseded this one -
            // applying it now would clobber `zones` with the wrong tab's data.
            if (requestId !== undefined && requestId !== this._zoneRequestId) {
                return;
            }
            // Legacy SOB Zone records can carry mixed case (e.g. "South" instead
            // of "SOUTH") - normalize here so this screen's own dropdown/upload
            // validation don't keep re-offering/accepting that bad casing as
            // "valid", and dedupe in case both casings exist as separate legacy
            // rows for what should be the same zone.
            var seen = new Set();
            var zones = [];
            (response.data || []).forEach((item) => {
                var normalized = String(item || "").trim().toUpperCase();
                if (normalized && !seen.has(normalized)) {
                    seen.add(normalized);
                    zones.push({ label: normalized, value: normalized });
                }
            });
            zones.unshift({ label: "All Zones", value: "" });
            var selectedZone = "";
            return new Promise(resolve => this.setState({ zones, selectedZone }, resolve));
        }).catch((e) => {
            console.log(e);
        });
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = async () => {
        await this.setState({
            show: false
        });
        await this.onloadPageData()
    }


    
    onClickBulkDelete(array) {
        var rowIdArray = array;
        if (rowIdArray.length == 0) {
            this.setState({
                show: true,
                basicType: "warning",
                basicTitle: "Please select rows"
            });
            return;
        }
        // console.log(e.data._id);
        var qry = {
            rowIds: rowIdArray,
            // vehicle_cap: cap,
            comp_code: localStorage.getItem('comp_code'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
            data_type: this.state.data_type, hub_vehicle: this.state.hub_vehicle, air_courier_vehicle: this.state.air_courier_vehicle,
            zone: this.state.selectedZone || ""
        }
        //var confirm = confirm("Are You Sure! Do you want really delete?");
        if (window.confirm("Are You Sure! Do you want really delete?")) {
            redirectURL.post("/lmconsignees/deleteLmVehicleCapacity", qry).then((response) => {
                console.log(response.data);
                if (response.data.message == "Success") {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        rowIds: [],
                        basicTitle: "Deleted Successfully.",
                        basicType: "success",
                        show: true,
                        selectedRows: []
                    })
                    //window.location.reload();
                    this.onloadPageData();
                }
                else {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        basicTitle: "Failed to Delete.",
                        basicType: "warning",
                        show: true
                    })
                }
            }).catch((e) => {
                console.log(e);
            })
        } else {
            this.setState({
                loadshow: 'show-n',
                overly: 'show-n'
            })
        }
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: "",
            validData: [],
            errors: [],
            fileName: ""
        });

    }
    updateLmStates(params) {
        console.log(params);
        // Capture the add/update intent before the API call resolves, since
        // this.state.controller may be reset (controller: { open: false }) by the
        // time the success callback below runs.
        var isAddAction = this.state.controller && this.state.controller.type === "add";
        // 'max_consignee_cmt' is collected on the HUB tab only (client, 2026-08-25). The field is
        // inactive on the other tabs, so requiring it here would block every Regular / Dedicated
        // / Surface Courier save outright.
        var maxConsigneeOk = !this.isHubTab() || (params.max_consignee_cmt != null && params.max_consignee_cmt != undefined);
        if (params.vehicle_cap != null && params.vehicle_cap != undefined && params.vehicle_capacity != null && params.vehicle_capacity != undefined && params.min_capacity_cmt != null && params.min_capacity_cmt != undefined && params.max_capacity_cmt != null && params.max_capacity_cmt != undefined && params.min_courier != null && params.min_courier != undefined && maxConsigneeOk && params.minimum_nodes != null && params.minimum_nodes != undefined && params.nodes_per_truck != null && params.nodes_per_truck != undefined && params.recommendation_cmt != null && params.recommendation_cmt != undefined) {
            var vehicle_capacity = params.vehicle_capacity;
            var minCap = params.min_capacity_cmt;
            var maxCap = params.max_capacity_cmt;
            var minCourier = params.min_courier;
            var deviation = parseFloat(params.deviation_allowed);
            var recCmt = params.recommendation_cmt;
            var newParams = {}
            if (minCap < vehicle_capacity) {
                if (minCap < maxCap) {
                    if (minCourier <= minCap) {
                        if (recCmt <= minCap) {
                            // if(deviation <= 100)
                            // {
                            var loading_port_code = this.state.loading_port_code;
                            newParams["data"] = [params]
                            newParams["loading_port_code"] = loading_port_code;
                            newParams['user_name'] = localStorage.getItem('username');
                            newParams['email'] = localStorage.getItem('email');
                            newParams['staff_id'] = localStorage.getItem('staff_id');
                            newParams['user_department'] = localStorage.getItem('lm_department');
                            newParams['designation'] = localStorage.getItem('designation');
                            newParams['comp_code'] = this.state.comp_code;
                            newParams['user_role'] = localStorage.getItem('roles');
                            newParams['data_type'] = this.state.data_type;
                            newParams['hub_vehicle'] = this.state.hub_vehicle;
                            newParams['air_courier_vehicle'] = this.state.air_courier_vehicle;
                            newParams['zone'] = this.isZoneTab() ? (params.zone || this.state.selectedZone || "") : "";
                            redirectURL.post("/lmconsignees/savelmvehiclecapacity", newParams).then((response) => {
                                console.log(response);
                                if (response.data.status == "success") {
                                    this.setState({
                                        basicTitle: (isAddAction ? "Added Successfully." : "Updated Successfully."),
                                        basicType: "success",
                                        show: true,
                                        controller: {
                                            open: false
                                        }
                                    })
                                    //window.location.reload();
                                    this.onloadPageData();
                                }
                                else {
                                    var errMsg = response.data.message;
                                    if (response.data.message == "Vehicle Already Exists") {
                                        var errMsg = response.data.message;
                                    }
                                    this.setState({
                                        basicTitle: errMsg,
                                        basicType: "warning",
                                        show: true
                                    })
                                }
                            })
                            // }
                            // else
                            // {
                            //     this.setState({
                            //         basicTitle:"Deviation Distance(%) should be less than or equal to 100",
                            //         basicType : "warning",
                            //         show : true
                            //     })
                            // }
                        }
                        else {
                            this.setState({
                                basicTitle: "Recommendation CMT should be less than or equal to Min Capacity(CMT)",
                                basicType: "warning",
                                show: true
                            })
                        }
                    }
                    else {
                        this.setState({
                            basicTitle: "Min CMT per Consignee should be less than Min Capacity(CMT)",
                            basicType: "warning",
                            show: true
                        })
                    }
                }
                else {
                    this.setState({
                        basicTitle: "Max Capacity(CMT) should be greater than Min Capacity(CMT).",
                        basicType: "warning",
                        show: true
                    })
                }
            }
            else {
                this.setState({
                    basicTitle: "Min Capacity(CMT) should not be greater than Vehicle Capacity(CMT).",
                    basicType: "warning",
                    show: true
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        // console.log(this.gridApi);
        // this.gridApi.insertItemsAtIndex(0, [{ vehicle_cap: "", vehicle_capacity: "", min_capacity_cmt: "", max_capacity_cmt: "", min_courier: "", nodes_per_truck: "", allowed_distance: "", telescopic_route: "", recommendation_cmt: "", last_consignee_cmt: "" }])
        // this.gridApi.updateRowData({add:[{holiday_date:"",holiday_name:""}]});
        var vehicleArray = this.state.hub_vehicle == 1 ? this.state.hubVehicleTypes : this.state.vehicleTypes
        // 'Max CMT Per Consignee' is a HUB-ONLY rule (client, 2026-08-25) - see the field below.
        var isHubOnlyField = this.isHubTab();
        var telRoutesArray = this.state.telRoutes.map((each) => ({ label: each, value: each }));
        var maxNodesArray = this.state.maxNodes.map((each) => ({ label: each, value: each }));
        var vehicleTypeArray = vehicleArray.map((each) => ({ label: each, value: each }));
        var deviationArray = this.state.deviation.map((each) => ({ label: each, value: each }));
        var isAllZones = this.state.selectedZone === "" || this.state.selectedZone === null;
        var zonesArray = this.state.zones.filter(z => z.value !== "");
        var formResourceArray = [
            {
                id: 1,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleTypeArray,
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "Vehicle Capacity",
                field: "vehicle_capacity",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the vehicle capacity.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Min Capacity (CMT)",
                field: "min_capacity_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the min capacity (CMT).",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Max Capacity (CMT)",
                field: "max_capacity_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the max capacity (CMT).",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 5,
                title: "Min CMT per Consignee",
                field: "min_courier",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Min CMT per Consignee.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                // Max CMT a SINGLE dealer may carry on a trip of this vehicle type.
                // WHOLE CMT (integer). 0 = not configured = no limit (the engine
                // treats 0/blank as "no limit"). Free numeric input with is_integer -
                // a CMT can be any whole number, so NOT a dropdown of node counts.
                //
                // HUB TAB ONLY (client decision 2026-08-25): the ceiling applies to HUB
                // vehicle types and is measured against the dealer's WHOLE load. On every
                // other tab the field is inactive (so it is neither rendered nor required)
                // and Node stores 0 = no limit.
                id: 51,
                title: "Max CMT Per Consignee",
                field: "max_consignee_cmt",
                type: "input",
                input_type: "number",
                is_integer: true,
                note: "HUB vehicles only. A consignee whose whole load exceeds this is not planned in hub. 0 = no limit.",
                errMsg: "Please enter the Max CMT Per Consignee.",
                is_active: isHubOnlyField,
                is_disabled: false,
                is_required: isHubOnlyField
            },
            {
                id: 61,
                title: "Minimum Nodes",
                field: "minimum_nodes",
                type: "dropdown",
                optionsArray: maxNodesArray,
                errMsg: "Please select Minimum Nodes.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 6,
                title: "Maximum Nodes",
                field: "nodes_per_truck",
                type: "dropdown",
                optionsArray: maxNodesArray,
                errMsg: "Please select Maximum Nodes.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 7,
                title: "Max Distance",
                field: "allowed_distance",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Max Distance.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 8,
                title: "Telescopic Route",
                field: "telescopic_route",
                type: "dropdown",
                optionsArray: telRoutesArray,
                errMsg: "Please select the telescopic route.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 9,
                title: "Deviation Distance (%)",
                field: "deviation_allowed",
                type: "dropdown",
                optionsArray: deviationArray,
                errMsg: "Please select the deviation distance.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 10,
                title: "Recommendation CMT",
                field: "recommendation_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Recommendation CMT.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 11,
                title: "Last Consignee CMT",
                field: "last_consignee_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Last Consignee CMT.",
                is_active: false,
                is_disabled: false,
                is_required: true
            }
        ];
        if (this.isZoneTab()) {
            formResourceArray.unshift({
                id: 0,
                title: this.isHubTab() ? "Hub" : "Zone",
                field: "zone",
                type: "dropdown",
                optionsArray: zonesArray,
                errMsg: this.isHubTab() ? "Please select a hub." : "Please select a zone.",
                is_active: true,
                is_disabled: !isAllZones,
                is_required: true
            });
        }
        this.setState({
            controller: {
                open: true,
                title: "Add New Vehicle Details",
                btnType: "Add",
                formResourceArray: formResourceArray,
                type: "add",
                formData: this.isZoneTab() ? { zone: this.state.selectedZone } : {}
            }
        })
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        var params = {
            fileName: "vehicle_details.csv"
        };
        this.gridApi.exportDataAsCsv(params);
    }
    showBulkUpload() {
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate",
            errors: [],
            validData: [],
            fileName: ""
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var dt = '';
        // csv-file-validator is STRICTLY POSITIONAL: it reads config.headers[columnIndex] and
        // flags the row when row.length !== config.headers.length. So this list has to mirror the
        // template THIS tab offers for download, column for column, in order:
        //   Hub tab           -> sample_vehicle_details_hub.csv      ('Hub',  WITH Max CMT Per Consignee)
        //   Regular tab       -> sample_vehicle_details.csv          ('Zone', without it)
        //   Dedicated/Courier -> sample_vehicle_details_no_zone.csv  (no zone column, without it)
        //
        // It used to be a FIXED 12-entry list that began with 'id', ended with 'Telescopic Route'
        // and had NO zone/hub column, so it matched none of the three templates: every column was
        // read one position off (Vehicle Type parsed into `id`, Zone into `vehicle_cap`, ...) and
        // the resulting errors were swallowed by an empty .catch, so a CSV upload silently did
        // nothing or pushed shifted rows. Built per tab now, and the errors are shown.
        var reqErr = function (headerName, rowNumber, columnNumber) {
            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
        };
        var headers = [
            { name: 'Vehicle Type', inputName: 'vehicle_cap', required: true, requiredError: reqErr }
        ];
        // Regular keys rows per zone, Hub per hub - same column, different label in the template.
        // Node takes the zone from the screen's selector (req.body.zone), not from the row, so this
        // entry exists mainly to consume the column at the right position.
        if (this.isZoneTab()) {
            headers.push({ name: this.isHubTab() ? 'Hub' : 'Zone', inputName: 'zone', required: false, requiredError: reqErr });
        }
        headers.push(
            { name: 'Vehicle Capacity (CMT)', inputName: 'vehicle_capacity', required: true, requiredError: reqErr },
            { name: 'Min Capacity (CMT)', inputName: 'min_capacity_cmt', required: false, requiredError: reqErr },
            { name: 'Max Capacity (CMT)', inputName: 'max_capacity_cmt', required: false, requiredError: reqErr },
            { name: 'Min CMT per Consignee', inputName: 'min_courier', required: false, requiredError: reqErr }
        );
        // HUB TAB ONLY - the ceiling applies to hub vehicle types, so the column only exists in
        // the hub template (client, 2026-08-25).
        if (this.isHubTab()) {
            headers.push({ name: 'Max CMT Per Consignee', inputName: 'max_consignee_cmt', required: true, requiredError: reqErr });
        }
        headers.push(
            { name: 'Minimum Nodes', inputName: 'minimum_nodes', required: true, requiredError: reqErr },
            { name: 'Maximum Nodes', inputName: 'nodes_per_truck', required: false, requiredError: reqErr },
            { name: 'Max Distance', inputName: 'allowed_distance', required: false, requiredError: reqErr },
            { name: 'Recommendation CMT', inputName: 'recommendation_cmt', required: false, requiredError: reqErr }
        );
        const config = {
            headers: headers
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                // Show the validator's complaints instead of swallowing them. Silently keeping a
                // bad file was what hid the positional mismatch above: the user pressed Upload and
                // nothing happened, with no clue why.
                var problems = (csvData && csvData.inValidMessages) ? csvData.inValidMessages : [];
                if (problems.length > 0) {
                    this.setState({
                        csvData: '',
                        file: '',
                        basicTitle: 'Please download the sample template for this tab and match its columns. ' + problems.slice(0, 3).join(' | '),
                        basicType: 'warning',
                        show: true
                    });
                    return;
                }
                this.setState({
                    csvData: csvData.data
                });
            })
            .catch(err => {
                this.setState({
                    csvData: '',
                    file: '',
                    basicTitle: 'Could not read the CSV file. Please check the file and try again.',
                    basicType: 'warning',
                    show: true
                });
            })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.setState({
            file: e.target.files[0]
        });
        //this.checkFileData();
        //console.log("e.target.files[0].name ", e.target.files[0].name);
        var check = verifyext(e.target.files[0].name);
        //console.log("Check ", check)
        if (check == true) {
            if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }
    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        var flag = 0;
        console.log(fileData, "fileData");
        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        console.log("verifycsvdata ", vdata)
        if (vdata == true) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
        else {
            if (flag == 0) {
                if (fileData.length > 0) {
                    var loading_port_code = this.state.loading_port_code;
                    var reqParams = {
                        csvData: fileData,
                        loading_port_code: loading_port_code
                    }
                    reqParams["loading_port_code"] = loading_port_code;
                    reqParams['user_name'] = localStorage.getItem('username');
                    reqParams['email'] = localStorage.getItem('email');
                    reqParams['staff_id'] = localStorage.getItem('staff_id');
                    reqParams['user_department'] = localStorage.getItem('lm_department');
                    reqParams['designation'] = localStorage.getItem('designation');
                    reqParams['comp_code'] = localStorage.getItem('comp_code');
                    reqParams['user_role'] = localStorage.getItem('roles');
                    reqParams['data_type'] = this.state.data_type;
                    reqParams['zone'] = this.isRegularTab() ? (this.state.selectedZone || "") : "";
                    console.log("reqParams", reqParams)
                    redirectURL.post("/lmconsignees/savebulklmvehiclecapacity", reqParams).then((response) => {
                        var resp = response.data.message;
                        console.log(resp)
                        this.setState({
                            basicTitle: resp,
                            basicType: "success",
                            show: true,
                            bulkslide: '',
                            overly: 'show-n',
                        })
                        //window.location.reload();
                        this.onloadPageData();
                    }).catch((e) => {
                        console.log(e);
                    })
                }
                else {
                    this.setState({
                        basicTitle: "Invalid File",
                        basicType: "warning",
                        show: true,
                    })
                }
                $('#upform')[0].reset();
            }
            else {
                $("#bulkUploadID").val();
                this.setState({
                    basicTitle: "Fields Should not be Empty",
                    basicType: "warning",
                    show: true,
                })
                $('#upform')[0].reset();
            }
        }
    };




    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange();
        }
    }
    onGlobalPortChange = async () => {
        var selectedPlant = this.context.loading_port_code;
        if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
            // Not a valid port for this screen — keep this screen's own selection, don't refetch.
            return;
        }
        try {
            const response = await redirectURL.post("/lmconsignees/getLoadingPlantDetails", { selectedPlant });
            var res = response.data;
            this.setState({
                loading_port_code: selectedPlant,
                comp_code: res[0].comp_code,
                selectedZone: null,
            });
            await this.loadZoneOptions(selectedPlant);
            this.loadWarehouseConfig(selectedPlant);
            await this.onloadPageData();
        } catch (e) {
            console.log("Error ", e);
        }
    }

    onClickTab = async (data_type, type) => {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        var airCourierActive = "";
        if (data_type == 1 && type !== "hub" && type !== "airCourier") {
            regularActive = "activet";
        }
        else if (data_type == 2) {
            truckActive = "activet";
        }
        else if (data_type == 3) {
            courierActive = "activet";
        } 
        else if (data_type == 1 && type === "hub") {
            hubActive = "activet";
        } else if (data_type == 1 && type === "airCourier") {
            airCourierActive = "activet";
        }
        this.setState({
            data_type: data_type,
            hub_vehicle: type === "hub" ? 1 : 0,
            air_courier_vehicle: type === "airCourier" ? 1 : 0,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            hubActive: hubActive,
            airCourierActive: airCourierActive
        }, () => {
            // Reload the zone/hub option source for the newly active tab, then refresh the grid.
            Promise.resolve(this.loadZoneOptions(this.state.loading_port_code)).then(() => this.onloadPageData());
        });
        // await this.onloadPageData();
    }
    handleEdit = (params) => {
        // console.log(params)
        var vehicleArray = this.state.hub_vehicle == 1 ? this.state.hubVehicleTypes : this.state.vehicleTypes
        // 'Max CMT Per Consignee' is a HUB-ONLY rule (client, 2026-08-25) - see the field below.
        var isHubOnlyField = this.isHubTab();
        var telRoutesArray = this.state.telRoutes.map((each) => ({ label: each, value: each }));
        var maxNodesArray = this.state.maxNodes.map((each) => ({ label: each, value: each }));
        var vehicleTypeArray = vehicleArray.map((each) => ({ label: each, value: each }));
        var deviationArray = this.state.deviation.map((each) => ({ label: each, value: each }));
        var zonesArray = this.state.zones.filter(z => z.value !== "");
        var formResourceArray = [
            {
                id: 1,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleTypeArray,
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 2,
                title: "Vehicle Capacity",
                field: "vehicle_capacity",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the vehicle capacity.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Min Capacity (CMT)",
                field: "min_capacity_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the min capacity (CMT).",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Max Capacity (CMT)",
                field: "max_capacity_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the max capacity (CMT).",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 5,
                title: "Min CMT per Consignee",
                field: "min_courier",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Min CMT per Consignee.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                // Max CMT a SINGLE dealer may carry on a trip of this vehicle type.
                // WHOLE CMT (integer). 0 = not configured = no limit (the engine
                // treats 0/blank as "no limit"). Free numeric input with is_integer -
                // a CMT can be any whole number, so NOT a dropdown of node counts.
                //
                // HUB TAB ONLY (client decision 2026-08-25): the ceiling applies to HUB
                // vehicle types and is measured against the dealer's WHOLE load. On every
                // other tab the field is inactive (so it is neither rendered nor required)
                // and Node stores 0 = no limit.
                id: 51,
                title: "Max CMT Per Consignee",
                field: "max_consignee_cmt",
                type: "input",
                input_type: "number",
                is_integer: true,
                note: "HUB vehicles only. A consignee whose whole load exceeds this is not planned in hub. 0 = no limit.",
                errMsg: "Please enter the Max CMT Per Consignee.",
                is_active: isHubOnlyField,
                is_disabled: false,
                is_required: isHubOnlyField
            },
            {
                id: 61,
                title: "Minimum Nodes",
                field: "minimum_nodes",
                type: "dropdown",
                optionsArray: maxNodesArray,
                errMsg: "Please select Minimum Nodes.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 6,
                title: "Maximum Nodes",
                field: "nodes_per_truck",
                type: "dropdown",
                optionsArray: maxNodesArray,
                errMsg: "Please select Maximum Nodes.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 7,
                title: "Max Distance",
                field: "allowed_distance",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Max Distance.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 8,
                title: "Telescopic Route",
                field: "telescopic_route",
                type: "dropdown",
                optionsArray: telRoutesArray,
                errMsg: "Please select the telescopic route.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 9,
                title: "Deviation Distance (%)",
                field: "deviation_allowed",
                type: "dropdown",
                optionsArray: deviationArray,
                errMsg: "Please select the deviation distance.",
                is_active: false,
                is_disabled: false,
                is_required: true
            },
            {
                id: 10,
                title: "Recommendation CMT",
                field: "recommendation_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Recommendation CMT.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 11,
                title: "Last Consignee CMT",
                field: "last_consignee_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the Last Consignee CMT.",
                is_active: false,
                is_disabled: false,
                is_required: true
            }
        ];
        if (this.isZoneTab()) {
            formResourceArray.unshift({
                id: 0,
                title: this.isHubTab() ? "Hub" : "Zone",
                field: "zone",
                type: "dropdown",
                optionsArray: zonesArray,
                errMsg: this.isHubTab() ? "Please select a hub." : "Please select a zone.",
                is_active: true,
                is_disabled: true,
                is_required: true
            });
        }
        this.setState({
            controller: {
                open: true,
                title: "Edit Vehicle Details",
                btnType: "Update",
                formResourceArray: formResourceArray,

                type: "update",
                formData: params.data || {}
            }
        })
    };
    handleDelete = async (params) => {
        this.setState({
            rowIds: [params.data._id],
            loadshow: 'show-m',
            overly: 'show-m',
        }, () => {
            this.onClickBulkDelete([params.data._id]);
        })
    };
    ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEdit(props) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleDelete(props) }} />
        </div>
    );
    onUpdateFreight = (object) => {
        let new_object;

        // If this is an edit (not an add) and none of the editable fields actually
        // changed from the original row, skip the API call and just inform the user.
        if (this.state.controller && this.state.controller.type === "update") {
            var compareFields = ["vehicle_capacity", "min_capacity_cmt", "max_capacity_cmt", "min_courier", "minimum_nodes", "nodes_per_truck", "allowed_distance", "recommendation_cmt"];
            // 'max_consignee_cmt' is only editable on the Hub tab, so comparing it elsewhere
            // would report a change the user cannot have made (stored value vs the forced 0).
            if (this.isHubTab()) {
                compareFields.push("max_consignee_cmt");
            }
            if (this.isRegularTab()) {
                compareFields.push("zone");
            }
            var originalData = this.state.controller.formData || {};
            var isUnchanged = compareFields.every((field) => {
                var oldVal = originalData[field];
                var newVal = object[field];
                var oldStr = (oldVal === null || oldVal === undefined) ? "" : String(oldVal).trim();
                var newStr = (newVal === null || newVal === undefined) ? "" : String(newVal).trim();
                return oldStr === newStr;
            });
            if (isUnchanged) {
                this.setState({
                    basicTitle: "No Changes Made.",
                    basicType: "warning",
                    show: true,
                    controller: {
                        open: false
                    }
                });
                return;
            }
        }

        if (!("telescopic_route" in object)) {
            new_object = {
                ...object,
                vehicle_cap: object.vehicle_cap,
                vehicle_capacity: Number(object.vehicle_capacity),
                min_capacity_cmt: Number(object.min_capacity_cmt),
                max_capacity_cmt: Number(object.max_capacity_cmt),
                min_courier: Number(object.min_courier),
                // HUB tab only - 0 (= no limit) everywhere else. Node enforces the same rule.
                max_consignee_cmt: (this.isHubTab() && object.max_consignee_cmt) ? parseInt(object.max_consignee_cmt, 10) : 0,
                minimum_nodes: object.minimum_nodes ? Number(object.minimum_nodes) : 1,
                nodes_per_truck: Number(object.nodes_per_truck),
                allowed_distance: Number(object.allowed_distance),
                deviation_allowed: 20,
                telescopic_route: 1,
                recommendation_cmt: Number(object.recommendation_cmt),
                last_consignee_cmt: 5,
                loading_port_code: this.state.loading_port_code,
                data_type: this.state.data_type,
                hub_vehicle: this.state.hub_vehicle,
                air_courier_vehicle: this.state.air_courier_vehicle
            };
        } else {
            new_object = {
                ...object,
                vehicle_cap: object.vehicle_cap,
                vehicle_capacity: Number(object.vehicle_capacity),
                min_capacity_cmt: Number(object.min_capacity_cmt),
                max_capacity_cmt: Number(object.max_capacity_cmt),
                min_courier: Number(object.min_courier),
                // HUB tab only - 0 (= no limit) everywhere else. Node enforces the same rule.
                max_consignee_cmt: (this.isHubTab() && object.max_consignee_cmt) ? parseInt(object.max_consignee_cmt, 10) : 0,
                minimum_nodes: object.minimum_nodes ? Number(object.minimum_nodes) : 1,
                nodes_per_truck: Number(object.nodes_per_truck),
                allowed_distance: Number(object.allowed_distance),
                // deviation_allowed: 20,
                // telescopic_route: 1,
                recommendation_cmt: Number(object.recommendation_cmt),
                // last_consignee_cmt: 5
                loading_port_code: this.state.loading_port_code,
                data_type: this.state.data_type,
                hub_vehicle: this.state.hub_vehicle,
                air_courier_vehicle: this.state.air_courier_vehicle
            }; // clone to avoid mutation
        }

        this.updateLmStates(new_object);
    }
    onRowSelection(event) {
        var rowIds = [];
        var rwCount = event.api.getSelectedNodes();
        rwCount.map((item) => {
            rowIds.push(item.data._id)
        });

        this.setState({
            rowIds: rowIds
        })
    }
    onExportClick = () => {
        if (this.gridRef.current && this.gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            this.gridRef.current.api.exportDataAsExcel({
                fileName: "vehicle_details.xlsx"
            });
        }
    };
    handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        this.setState({ fileName: file.name })

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {
            // Without this try/catch, a file XLSX can't parse (wrong format,
            // corrupted, a protected/empty sheet) throws here uncaught -
            // validateExcelData never runs, errors/validData stay at their
            // untouched [] defaults, and Submit sits disabled with nothing in
            // the Validation Errors table to explain why.
            try {
                const workbook = XLSX.read(
                    new Uint8Array(event.target.result),
                    { type: "array" }
                );

                const sheet = workbook.Sheets[workbook.SheetNames[0]];

                const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                this.validateExcelData(data);
            } catch (e) {
                console.error(e);
                this.setState({
                    errors: [{ row: "", errors: ["Could not read this file - please check it's a valid Excel/CSV file and try again."] }],
                    validData: []
                });
            }
        };
    };
    validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let vehicleType = getCellValue(row, "Vehicle Type");
            let vehicleCapacity = getCellValue(row, "Vehicle Capacity (CMT)");
            let minCapacity = getCellValue(row, "Min Capacity (CMT)");
            let maxCapacity = getCellValue(row, "Max Capacity (CMT)");
            let minCmtPerConsignee = getCellValue(row, "Min CMT per Consignee");
            let maxCmtPerConsignee = getCellValue(row, "Max CMT Per Consignee");
            let minimumNodes = getCellValue(row, "Minimum Nodes");
            let nodesPerTruck = getCellValue(row, "Maximum Nodes");
            let maxDistance = getCellValue(row, "Max Distance");
            let recommendationCMT = getCellValue(row, "Recommendation CMT");
            // Column name matches whichever sample template this tab actually
            // hands out - "Hub" for the Hub tab's own template
            // (sample_vehicle_details_hub.csv), "Zone" for the regular tab's.
            let zone = this.isZoneTab() ? String(getCellValue(row, this.isHubTab() ? "Hub" : "Zone") || "").trim() : undefined;

            let rowErrors = [];

            // -------- Basic Validations --------
            if (this.isZoneTab()) {
                // Regular validates against SOB zones; Hub validates against the hubs loaded
                // into `zones` from the hub master. Same mechanism, same error format.
                const validZones = this.state.zones.filter(z => z.value !== "").map(z => z.value);
                const label = this.isHubTab() ? "Hub" : "Zone";
                const matchedZone = zone ? validZones.find((z) => isSameIgnoreCase(z, zone)) : null;
                if (!matchedZone) {
                    rowErrors.push(`${label} "${zone}" is invalid. Valid ${this.isHubTab() ? "hubs" : "zones"}: ${validZones.join(", ")}`);
                } else {
                    zone = matchedZone;
                }
            }

            const vehicleTypeList = this.state.hub_vehicle == 1 ? this.state.hubVehicleTypes : this.state.vehicleTypes;
            const matchedVehicleType = vehicleTypeList.find((each) => isSameIgnoreCase(each, vehicleType));
            if (!matchedVehicleType) {
                rowErrors.push(`Vehicle Type "${vehicleType}" is invalid`);
            } else {
                vehicleType = matchedVehicleType;
            }

            if (!this.isValidNumber(vehicleCapacity)) {
                rowErrors.push(`Vehicle Capacity should be numeric (${vehicleCapacity})`);
            }

            if (!this.isValidNumber(minCapacity)) {
                rowErrors.push(`Min Capacity should be numeric (${minCapacity})`);
            }

            if (!this.isValidNumber(maxCapacity)) {
                rowErrors.push(`Max Capacity should be numeric (${maxCapacity})`);
            }

            if (!this.isValidNumber(minCmtPerConsignee)) {
                rowErrors.push(`Min CMT per Consignee should be numeric (${minCmtPerConsignee})`);
            }

            // Max CMT Per Consignee: HUB TAB ONLY (client, 2026-08-25) - it caps a dealer's WHOLE
            // load on a hub vehicle type. Mandatory and a WHOLE number (CMT) on the Hub tab
            // (enter 0 to mean "not configured = no limit"); on every other tab the column is
            // ignored entirely, so a sheet that still carries it must not fail validation.
            if (!this.isHubTab()) {
                // not validated off the Hub tab
            }
            else if (maxCmtPerConsignee === undefined || String(maxCmtPerConsignee).trim() === "") {
                rowErrors.push(`Max CMT Per Consignee is required (enter 0 for no limit)`);
            }
            else if (!this.isValidNumber(maxCmtPerConsignee)) {
                rowErrors.push(`Max CMT Per Consignee should be numeric (${maxCmtPerConsignee})`);
            }
            else if (!this.isWholeNumber(maxCmtPerConsignee)) {
                rowErrors.push(`Max CMT Per Consignee should be a whole number (CMT) (${maxCmtPerConsignee})`);
            }

            // Minimum Nodes is MANDATORY (enter 1 for no floor). Validated before Maximum Nodes
            // so the row errors read in the same order the columns are presented.
            if (minimumNodes === undefined || String(minimumNodes).trim() === "") {
                rowErrors.push(`Minimum Nodes is required (enter 1 for no floor)`);
            } else if (!this.isValidNumber(minimumNodes)) {
                rowErrors.push(`Minimum Nodes should be numeric (${minimumNodes})`);
            }

            if (!this.isValidNumber(nodesPerTruck)) {
                rowErrors.push(`Maximum Nodes should be numeric (${nodesPerTruck})`);
            }

            if (!this.isValidNumber(maxDistance)) {
                rowErrors.push(`Max Distance should be numeric (${maxDistance})`);
            }

            if (!this.isValidNumber(recommendationCMT)) {
                rowErrors.push(`Recommendation CMT should be numeric (${recommendationCMT})`);
            }

            // -------- Business Validations --------
            if (rowErrors.length === 0) {

                const vCap = Number(vehicleCapacity);
                const minCap = Number(minCapacity);
                const maxCap = Number(maxCapacity);
                const minCourier = Number(minCmtPerConsignee);
                const recCmt = Number(recommendationCMT);
                const dist = Number(maxDistance);

                if (minCap >= vCap) {
                    rowErrors.push(`Min Capacity (${minCap}) must be less than Vehicle Capacity (${vCap})`);
                }

                if (minCap >= maxCap) {
                    rowErrors.push(`Max Capacity (${maxCap}) must be greater than Min Capacity (${minCap})`);
                }

                if (minCourier > minCap) {
                    rowErrors.push(`Min CMT per Consignee (${minCourier}) must be ≤ Min Capacity (${minCap})`);
                }

                if (recCmt > minCap) {
                    rowErrors.push(`Recommendation CMT (${recCmt}) must be ≤ Min Capacity (${minCap})`);
                }

                // // Optional rule (you had earlier)
                // if (dist > 100) {
                //     rowErrors.push(`Max Distance (${dist}) should be ≤ 100`);
                // }
            }

            // -------- Final Handling --------
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                cleanedData.push({
                    vehicle_cap: vehicleType,
                    vehicle_capacity: Number(vehicleCapacity),
                    min_capacity_cmt: Number(minCapacity),
                    max_capacity_cmt: Number(maxCapacity),
                    min_courier: Number(minCmtPerConsignee),
                    // HUB tab only - 0 (= no limit) on every other tab, whatever the sheet said.
                    max_consignee_cmt: (this.isHubTab() && maxCmtPerConsignee !== undefined && String(maxCmtPerConsignee).trim() !== "") ? parseInt(maxCmtPerConsignee, 10) : 0,
                    minimum_nodes: (minimumNodes !== undefined && String(minimumNodes).trim() !== "") ? Number(minimumNodes) : 1,
                    nodes_per_truck: Number(nodesPerTruck),
                    allowed_distance: Number(maxDistance),
                    deviation_allowed: 20,
                    telescopic_route: 1,
                    recommendation_cmt: Number(recommendationCMT),
                    last_consignee_cmt: 5,
                    ...(this.isZoneTab() ? { zone } : {})
                });
            }

        });

        // -------- Empty File Check --------
        if (cleanedData.length === 0 && errorList.length === 0) {
            errorList.push({
                row: "",
                errors: ["No data found. All rows are empty"]
            });
        }

        // -------- Set State --------
        this.setState({
            errors: errorList,
            validData: cleanedData
        });

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };
    handleBulkUpload = async () => {

        try {
            this.setState({
                loadshow: "show-m",
                overly: "show-m"
            })

            const finalData = this.state.validData.map((each) => {
                return (
                    {
                        ...each,
                        "loading_port_code": this.state.loading_port_code,
                        "status": 1, "hub_vehicle": this.state.hubActive == "activet" ? 1 : 0, "air_courier_vehicle": this.state.airCourierActive == "activet" ? 1 : 0,
                        "data_type": this.state.data_type,

                    }
                )
            })
            // console.log(this.state.validData, finalData)

            if (this.isZoneTab()) {
                const byZone = {};
                finalData.forEach(row => {
                    const z = row.zone || "";
                    if (!byZone[z]) byZone[z] = [];
                    byZone[z].push(row);
                });
                for (const [z, rows] of Object.entries(byZone)) {
                    await this.bulkUpdateTransporter(rows, z);
                }
            } else {
                await this.bulkUpdateTransporter(finalData, "");
            }
            await this.onloadPageData();
            this.setState({
                loadshow: "show-n",
                overly: "show-n",
                errors: [],
                validData: [],
                bulkslide: false,
                fileName: "",

            })
            if (this.fileInputRef.current) {
                this.fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };



    // isValidNumber = (value) => {
    //     const str = String(value || "").trim();
    //     return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    // };
    isValidNumber = (value) => {
        return value !== null &&
            value !== undefined &&
            value !== "" &&
            !isNaN(value) &&
            Number(value) >= 0;
    };
    // Whole (integer) CMT check - used by Max CMT Per Consignee, which the business
    // defines as whole CMT. Assumes isValidNumber() already passed.
    isWholeNumber = (value) => {
        return Number.isInteger(Number(value));
    };
    getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    bulkUpdateTransporter = async (array, zone = "") => {
        // console.log(object)
        var params = {
            data: array,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
            zone: zone,
        }
        try {

            const response = await redirectURL.post("/lmconsignees/savelmvehiclecapacity", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    isRegularTab() {
        return this.state.data_type == 1 && this.state.hub_vehicle == 0 && this.state.air_courier_vehicle == 0;
    }

    // HUB tab: vehicle details are keyed per HUB (like Regular is keyed per zone). The hub name
    // is stored in the same `zone` field / `selectedZone` state as Regular, so the whole
    // zone machinery (selector, add, edit-lock, bulk validation) is reused. The engine appends
    // the "_HUB" suffix at plan time; UI / Node / DB keep the bare hub name.
    isHubTab() {
        return this.state.data_type == 1 && this.state.hub_vehicle == 1;
    }

    // Tabs where a zone/hub selection applies (Regular = SOB zones, Hub = hubs).
    isZoneTab() {
        return this.isRegularTab() || this.isHubTab();
    }

    // Populate the `zones` dropdown from the hub master for the current warehouse.
    fetchHubs(loading_port_code, requestId) {
        return redirectURL.post("/masters/getHubMasterData", { loading_port_code, is_active: 1 }).then((response) => {
            // Same stale-response guard as fetchZones - see loadZoneOptions.
            if (requestId !== undefined && requestId !== this._zoneRequestId) {
                return;
            }
            var hubData = (response.data && response.data.hubData) || [];
            var zones = hubData.map((item) => ({
                label: item.hub_name,
                value: item.hub_name
            }));
            zones.unshift({ label: "All Hubs", value: "" });
            var selectedZone = "";
            return new Promise(resolve => this.setState({ zones, selectedZone }, resolve));
        }).catch((e) => {
            console.log(e);
        });
    }

    // Load the correct option source for the active tab: hubs on the HUB tab, SOB zones otherwise.
    // Tagged with a request id so a slower, superseded request (e.g. the user
    // switches tabs again before this one's response lands) can't clobber
    // `this.state.zones` with the wrong tab's data after the fact - see the
    // guard at the top of fetchHubs/fetchZones' .then() handlers.
    loadZoneOptions(loading_port_code) {
        this._zoneRequestId = (this._zoneRequestId || 0) + 1;
        var requestId = this._zoneRequestId;
        if (this.isHubTab()) {
            return this.fetchHubs(loading_port_code, requestId);
        }
        return this.fetchZones(loading_port_code, requestId);
    }

    onChangeZone = (selectedOption) => {
        if (!selectedOption) return;
        this.setState(
            { selectedZone: selectedOption.value },
            () => { this.onloadPageData(); }
        );
    }

    render() {
        var showActions = false;
        var showDelete = true;
        if (this.state.pageAccess == 2) {
            var showActions = true;
        }
        if (this.state.pageAccess == 3) {
            var showDelete = false;
        }
        var columnwithDefs = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 100,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 180,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.vechicleTypes,
                // },
            },
            {
                headerName: this.isHubTab() ? "Hub" : "Zone",
                field: "zone",
                width: 160,
                filter: true,
                resizable: true,
                valueGetter: (params) => {
                    if (!this.isZoneTab()) return "ALL";
                    return params.data.zone || "";
                }
            },
            {
                headerName: "Vehicle Capacity (CMT)",
                field: "vehicle_capacity",
                width: 180,
                filter: true,
                resizable: true,
                // editable: false,
            },
            {
                headerName: "Min Capacity (CMT)",
                field: "min_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                headerName: "Max Capacity (CMT)",
                field: "max_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                headerName: "Min CMT per Consignee",
                field: "min_courier",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                headerName: "Max CMT Per Consignee",
                field: "max_consignee_cmt",
                width: 180,
                filter: true,
                resizable: true,
                // HUB-ONLY rule: hidden on the other tabs, where the value is always 0
                // (= no limit) and showing it would imply a setting that does nothing.
                hide: !this.isHubTab(),
            },
            {
                headerName: "Minimum Nodes",
                field: "minimum_nodes",
                width: 160,
                filter: true,
                resizable: true,
            },
            {
                headerName: "Maximum Nodes",
                field: "nodes_per_truck",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.maxNodes,
                // },
            },
            {
                headerName: "Max Distance",
                field: "allowed_distance",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                headerName: "Telescopic Route",
                field: "telescopic_route",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.telRoutes,
                // },
                hide: true,
                valueGetter: function (params) {
                    console.log(params)
                    if (params.data.telescopic_route == 1) {
                        return "Enable";
                    }
                    else {
                        return "Disable------------------------";
                    }
                }
            },
            {
                headerName: "Deviation Distance (%)",
                field: "deviation_allowed",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.deviation,
                // },
                hide: true,
                valueGetter: function (params) {
                    if (params.data.deviation_allowed == "0" || params.data.deviation_allowed == 0) {
                        return "Disable";
                    }
                    else {
                        return params.data.deviation_allowed;
                    }
                }
            },
            {
                headerName: "Recommendation CMT",
                field: "recommendation_cmt",
                width: 160,
                filter: true,
                resizable: true,
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                headerName: "Last Consignee CMT",
                field: "last_consignee_cmt",
                width: 160,
                filter: true,
                resizable: true,
                hide: true
                // editable:true,
                // cellEditor: NumericCellEditor,
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 120,
                resizable: true,
                editable: false,
                hide: showActions || true,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
            },
            {
                pinned: "left",
                headerName: "Delete",
                field: "delete",
                width: 80,
                resizable: true,
                editable: false,
                hide: showDelete || true,
                cellRenderer: function (params) {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
            },
            {
                headerName: "id",
                field: "id",
                width: 59,
                filter: true,
                resizable: true,
                editable: false,
                hide: true,
            },
        ]
        var userroles = localStorage.getItem("roles")
        var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
        var disableUpload = this.state.validData.length == 0
        return (
            <div class="container-fluid" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {/* {this.state.loading_port_code == "GUR" ? ( */}
                    <div className="row" style={{ marginBottom: "10px" }}>

                        <div className="col-sm-12 d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>

                            <ul
                                style={{
                                    display: "inline-flex",
                                    flexWrap: "wrap",      // 🔥 prevents cutting
                                    padding: "4px",
                                    margin: 0,
                                    listStyle: "none",
                                    gap: "4px",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "10px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                                }}
                            >

                                {[
                                    { onClick: () => this.onClickTab(1, "hub"), label: "Hub", active: this.state.hubActive },
                                    { onClick: () => this.onClickTab(1, ""), label: "Regular", active: this.state.regularActive },
                                    { onClick: () => this.onClickTab(3, ""), label: "Dedicated", active: this.state.courierActive },
                                    { onClick: () => this.onClickTab(2, ""), label: "Surface Courier", active: this.state.truckActive },
                                ].map(({ onClick, label, active }, idx) => {
                                    var isActive = active == "activet";
                                    return (
                                        <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                            <button
                                                type="button"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    border: "none",
                                                    outline: "none",
                                                    borderRadius: "999px",
                                                    padding: "8px 18px",
                                                    fontSize: "13px",
                                                    fontWeight: isActive ? 600 : 500,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease",
                                                    backgroundColor: isActive ? "#1976d2" : "transparent",
                                                    color: isActive ? "#fff" : "#555",
                                                    boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                                }}
                                            >
                                                {label}
                                            </button>
                                        </li>
                                    );
                                })}

                            </ul>

                            {/* Warehouse-level Courier Hold CMT limit — tab-agnostic (one value per
                                warehouse, not per tab / vehicle type). Stored in lmwarehouseconfig. */}
                            <div className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "wrap" }}>
                                <label style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#1a237e", whiteSpace: "nowrap" }}>
                                    Courier Hold CMT Limit
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={this.state.courierHoldCmtLimit}
                                    onChange={(e) => this.setState({ courierHoldCmtLimit: e.target.value })}
                                    placeholder="0 = off"
                                    style={{ width: "80px", padding: "5px 8px", border: "1px solid #c5cddb", borderRadius: "4px", fontSize: "13px" }}
                                />
                                <button
                                    type="button"
                                    onClick={this.saveWarehouseConfig}
                                    disabled={this.state.savingWhConfig || !this.state.loading_port_code}
                                    style={{
                                        border: "none", borderRadius: "999px", padding: "7px 20px", fontSize: "13px",
                                        fontWeight: 600, cursor: "pointer", backgroundColor: "#1976d2", color: "#fff",
                                        boxShadow: "0 1px 4px rgba(25,118,210,0.4)",
                                        opacity: (this.state.savingWhConfig || !this.state.loading_port_code) ? 0.6 : 1
                                    }}
                                >
                                    {this.state.savingWhConfig ? "Saving..." : "Save"}
                                </button>
                                <span
                                    title="Any consignee whose courier load exceeds this CMT is marked Courier HOLD. Blank / 0 disables it."
                                    style={{
                                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                                        width: "18px", height: "18px", borderRadius: "50%", cursor: "help",
                                        border: "1px solid #1976d2", color: "#1976d2", fontSize: "12px",
                                        fontStyle: "italic", fontWeight: 700, lineHeight: 1
                                    }}
                                >i</span>
                            </div>

                        </div>
                    </div>
                {/* }) : null} */}

                <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "90%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <div className="d-flex justify-content-between align-items-center" style={{flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0}}>
                        <div className="d-flex align-items-center" style={{gap: "14px"}}>
                            <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                            <h5 style={{margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px"}}>Vehicle Details</h5>
                        </div>
                        <div className="d-flex align-items-center" style={{flexWrap: "wrap", gap: "8px"}}>
                            {this.isZoneTab() && <div className="d-flex align-items-center" style={{
                                backgroundColor: "#efefef", borderRadius: "999px",
                                padding: "4px 6px 4px 14px", gap: "4px"
                            }}>
                                <span style={{ fontSize: "13px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>{this.isHubTab() ? "Hub :" : "Zone :"}</span>
                                <div style={{ width: "120px" }}>
                                    <Select
                                        options={this.state.zones}
                                        value={this.state.zones.find((z) => z.value === this.state.selectedZone) || null}
                                        onChange={this.onChangeZone}
                                        placeholder="All"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: "28px",
                                                fontSize: "13px",
                                                backgroundColor: "transparent",
                                                border: "none",
                                                boxShadow: "none",
                                                cursor: "pointer"
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: "#263238",
                                                fontWeight: 600
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: "#263238",
                                                fontWeight: 600
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: "#263238"
                                            }),
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                padding: "0px 4px"
                                            }),
                                            indicatorsContainer: (provided) => ({
                                                ...provided,
                                                height: "28px"
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                padding: "4px",
                                                color: "#1976d2",
                                                cursor: "pointer"
                                            }),
                                            clearIndicator: (provided) => ({
                                                ...provided,
                                                padding: "4px",
                                                color: "#546e7a",
                                                cursor: "pointer"
                                            })
                                        }}
                                    />
                                </div>
                            </div>}
                            {(this.state.pageAccess == 3 && this.state.selectedRows.length > 0) ?
                                <button className="pill-btn pill-btn-danger" onClick={() => { this.onClickBulkDelete(this.state.selectedRows.map((each) => each._id)) }}>Delete</button>
                                : ""}
                            <button className="pill-btn pill-btn-primary" onClick={this.onExportClick.bind(this)}>Export Data</button>
                            {(this.state.pageAccess != 2) ?
                                <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                : ""}
                            {(this.state.pageAccess != 2) ?
                                <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>+ Add</button>
                                : ""}
                        </div>
                    </div>
                    {/* {(this.state.lpNames.length > 0) ?
                        <div className="row col-xl-12 col-lg-12" style={{ marginTop: "2%" }}>
                            <div className="col-xl-12 col-lg-12">
                                {this.state.lpNames.length == 1 ?
                                    <span style={{ fontSize: "16px" }}>Loading Plant : {(this.state.lpNames[0].loading_port)}</span>
                                    :
                                    <span style={{ fontSize: "16px" }}>Loading Plant :
                                        <select id="loadingPlant" onChange={this.onChangeLoadingPlant.bind(this)}>
                                            {(this.state.lpNames).map(function (obj) {
                                                return <option value={obj.loading_port_code}>{obj.loading_port}</option>
                                            })}
                                        </select>
                                    </span>
                                }
                            </div>
                        </div>
                        : ""} */}
                    <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                        {/* <div id="myGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham d-none" + this.state.showGridData}>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.rowData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}

                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onRowSelected={this.onRowSelection.bind(this)}
                            // onCellClicked={this.onCellClicked}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                            />
                        </div> */}
                        <div className="ag-theme-balham grid-wrapper mt-3 mb-3" style={{ flex: 1, minHeight: 0 }}>
                            <AgGridReact
                                ref={this.gridRef}
                                modules={this.state.modules}
                                rowData={this.state.rowData}
                                columnDefs={columnwithDefs}
                                defaultColDef={{
                                    sortable: true,
                                    filter: true,
                                    floatingFilter: true, resizable: true
                                }}

                                statusBar={{
                                    statusPanels: [
                                        { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                        { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                                    ]
                                }}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: 'columns',
                                            labelDefault: 'Columns',
                                            iconKey: 'columns',
                                            toolPanel: 'agColumnsToolPanel'
                                        },
                                        {
                                            id: 'filters',
                                            labelDefault: 'Filters',
                                            iconKey: 'filter',
                                            toolPanel: 'agFiltersToolPanel'
                                        }
                                    ],
                                    // defaultToolPanel: 'filters'
                                }}
                                animateRows rowSelection={"multiple"}
                                rowHeight={45}
                                headerHeight={45}
                                frameworkComponents={this.state.frameworkComponents}
                                onSelectionChanged={() => {
                                    if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                        const selected = this.gridRef.current.api.getSelectedRows();
                                        this.setState({ selectedRows: selected })
                                    }
                                }} suppressRowClickSelection={true}
                            />
                        </div>
                    </div>
                </div>


                {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                <div className={"slide-r d-none" + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                    <h3 className="subH">Bulk Upload</h3>
                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                <div className="form-group mt-20p">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                </div>
                                <div className="form-group">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                    <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default">Cancel</button>
                                </div>
                            </form>
                            <div className="form-group">
                                <a className="btn btn-primary" href={require('../../assets/json/sample_vehicle_details.csv')} target="_blank">Sample Template</a>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.controller.open && (
                    <>
                        <div
                            className="slider-overlay"
                            onClick={() => { this.setState((prevState) => ({ ...prevState, controller: false })) }}
                        />
                        <AddEditController
                            resource={this.state.controller}
                            onUpdate={this.onUpdateFreight}
                            closeSlider={() => { this.setState((prevState) => ({ ...prevState, controller: false })) }}
                        />
                    </>
                )}
                <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                    <div className="slider-header">
                        Import Data
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
                    </div>

                    <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                        <input
                            ref={this.fileInputRef}
                            type="file"
                            accept=".xlsx,.xls,.csv"
                            onChange={this.handleFileChange}
                            style={{ display: "none" }}
                        />
                        {/* Upload button */}
                        <div className="d-flex align-items-center gap-3">
                            <button
                                className="btn btn-info d-flex justify-content-center p-3"
                                type="button"
                                onClick={() => this.fileInputRef.current.click()}
                            >
                                Upload File
                            </button>

                            <a href={
                                // isHubTab() checked first - it's a more specific case of
                                // isZoneTab() (isZoneTab = isRegularTab() || isHubTab()), so this
                                // has to come before the isZoneTab() branch or Hub would always
                                // fall into the plain "Zone" template below instead of its own.
                                this.isHubTab()
                                    ? require('../../assets/json/sample_vehicle_details_hub.csv')
                                    : this.isZoneTab()
                                        ? require('../../assets/json/sample_vehicle_details.csv')
                                        : require('../../assets/json/sample_vehicle_details_no_zone.csv')
                            } className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                                Download Sample Template
                            </a>
                        </div>

                        {this.state.fileName && (
                            <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                                <span>Selected File :</span>
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontWeight: "bold"
                                    }}
                                    title={this.state.fileName}
                                >
                                    {this.getShortFileName(this.state.fileName)}
                                </span>
                            </div>
                        )}


                        {this.state.errors.length > 0 && (
                            <>
                                <h6 className="text-danger mt-3">Validation Errors</h6>

                                <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                    <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                        <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                            <tr>
                                                <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                                <th>Error Description</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.errors.map((err, i) => (
                                                <tr key={i}>
                                                    <td className="text-center" style={{ padding: "9px 15px" }}>
                                                        {err.row}
                                                    </td>

                                                    <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                        {err.errors.map((e, idx) => (
                                                            <p className="m-0" key={idx}>{e}</p>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                    </div>
                    <div className="slider-footer">
                        <button
                            className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                            onClick={this.handleBulkUpload}
                            disabled={disableUpload}
                        >
                            {errTrueUpload ? "Submit only valid data" : "Submit"}
                        </button>
                    </div>

                </div>
                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};